module.exports = __webpack_public_path__ + "img/riddles_diary.3a8e555d.jpg";